import React from "react";
import { connect } from "react-redux";
import "./_EmailModal.scss";
import { Header } from "..";
import { ReactComponent as Cross } from "../../assets/svg/cross.svg";
import {
  toggleEmailModal,
  sendEmail,
  sendEmailNecklace,
} from "../../redux/actions";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

class EmailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      to: "",
      sender: "",
      message: "",
    };
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleSubmit = (event) => {
    const { history } = this.props;
    event.preventDefault();
    if (history) {
      const queryParams = history
        ? queryString.parse(history.location.search)
        : null;
      if (queryParams && queryParams.view === "summary-necklace") {
        // Use different sendEmail action with rings and necklaces:
        this.props.sendEmailNecklace(
          queryParams,
          this.state.to,
          this.state.sender,
          this.state.message
        );
      } else {
        this.props.sendEmail(
          history,
          this.state.to,
          this.state.sender,
          this.state.message
        );
      }
    }
  };

  render() {
    const { emailModalOpen, titleText, sendingEmailText } = this.props;
    let modalIsOpen = false;
    if (emailModalOpen) {
      modalIsOpen = true;
    }
    const modalClass = modalIsOpen ? "email-modal open" : "email-modal";

    return (
      <div className={modalClass}>
        <Header titleText={titleText} />
        <button
          onClick={() => this.props.toggleEmailModal()}
          className="close-button"
        >
          <Cross className="close-button-icon" />
        </button>
        <div className="email-modal-container">
          <form onSubmit={this.handleSubmit}>
            <label>Vastaanottajan sähköposti</label>
            <input
              name="to"
              className="input-field"
              type="email"
              value={this.state.to}
              onChange={this.handleInputChange}
              required
            />
            <br />
            <label>Lähettäjän nimi</label>
            <input
              name="sender"
              className="input-field"
              type="text"
              value={this.state.sender}
              onChange={this.handleInputChange}
              required
            />
            <br />
            <label>Viesti</label>
            <textarea
              rows={8}
              className="text-field"
              name="message"
              value={this.state.message}
              onChange={this.handleInputChange}
              required
            />
            <input type="submit" value="Lähetä" className="submit-button" />
          </form>
          <span className="email-notification">{sendingEmailText}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ summaryPage }) => {
  const { emailModalOpen, sendingEmailText } = summaryPage;

  return {
    emailModalOpen,
    sendingEmailText,
  };
};

export default connect(mapStateToProps, {
  toggleEmailModal,
  sendEmail,
  sendEmailNecklace,
})(withRouter(EmailModal));
